import { css } from '@emotion/react';

import { Radius, Spacing } from 'chatie-design-system';

import Frame from './Frame';

const situationSkeletonCSS = (isDetail?: boolean) => css`
  display: flex;
  flex-direction: column;
  align-items: center;

  div:nth-of-type(1) {
    width: ${isDetail ? '165px' : '100px'};
    height: ${isDetail ? '165px' : '100px'};
    border-radius: ${Radius.medium}px;
    margin-bottom: ${Spacing.xhsmall}px;
  }

  div:nth-of-type(2) {
    width: ${isDetail ? '165px' : '100px'};
    height: 12px;
  }
`;

const SituationSkeleton = ({ isDetail }: { isDetail?: boolean }) => {
  return (
    <div css={situationSkeletonCSS(isDetail)}>
      <Frame />
      <Frame />
    </div>
  );
};

export default SituationSkeleton;
